import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setOverlayVisible } from './actions.js';
import { setOverlayPublisherVisible } from './actions.js';
import { setOverlayPartnerVisible } from './actions.js';

import Logo from '../../components/Svg/ActionButtonLogo';
import PublisherLogo from '../../components/Widget/PublisherLogo';
import PartnerLogo from '../../components/Widget/PartnerLogo';
import { SponsoredTag } from '../../components/Widget/SponsoredTag';

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    min-height: 24px;
`;

const LogoWrapper = styled.div`
    &.hide {
        display: none;
    }
`;

const WidgetHeader = props => (
    <Header>
        <Logo onClick={() => props.setOverlayVisible(true)} />
        <LogoWrapper>
            {props.partnerLogo && props.isPartnerLogoVisible && (
                <PartnerLogo
                    logoUrl={props.partnerLogo}
                    onClick={() => props.setOverlayPartnerVisible(true)}
                />
            )}
            {props.isSponsored && <SponsoredTag />}
            {props.publisherLogoUrl && !props.isPartnerLogoVisible && (
                <PublisherLogo
                    logoUrl={props.publisherLogoUrl}
                    onClick={() => props.setOverlayPublisherVisible(true)}
                />
            )}
        </LogoWrapper>
    </Header>
);

WidgetHeader.propTypes = {
    publisherLogoUrl: PropTypes.string,
    partnerLogo: PropTypes.string,
    setOverlayVisible: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    setOverlayPublisherVisible: PropTypes.func.isRequired,
    isPartnerLogoVisible: PropTypes.bool.isRequired,
    isSponsored: PropTypes.bool
};

export default connect(
    state => {
        return {
            publisherLogoUrl: state.widget.publisherLogoUrl,
            partnerLogo: (state.widget.selectedPartner || {}).logoUrl,
            isPartnerLogoVisible:
                state.widget.cards[state.widget.activeAction.order - 1].logoSource === 1
                    ? true
                    : false,
            isSponsored: state.widget.isSponsored
        };
    },
    { setOverlayVisible, setOverlayPublisherVisible, setOverlayPartnerVisible }
)(WidgetHeader);



// WEBPACK FOOTER //
// ./src/containers/Widget/WidgetHeader.jsx